import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { generateClient } from 'aws-amplify/api';
import charmhealthlogo_placeholder from '../../../assets/charmhealthlogo_placeholder.jpg';
import { heroBackground, navbarFixedStyling, heroSearchbarCategoriesContainer, heroSearchbarCategoriesButton, heroSearchbarIconContainer, heroSearchbarCategoriesDropdownContainer, heroSearchbarCategoriesDropdownItem, heroSearchbarSuggestionsDropdownContainer } from '../../../Constants/Styles';
import { MagnifyingGlassIcon, ExpandDropdownIcon, CollapseDropdownIcon } from '../../../Constants/Icons';
import MainNav from '../../Common/MainNav';
import { buttonLabels } from '../../../Constants/Data';
import { retrieveProducts } from '../../API/API_Handler';

import BackgroundImage from '../../../assets/BackgroundImage.png';

const MainHero = () => {
    const navigate = useNavigate();

    const [dataLayer, setDataLayer] = useState([]);

    const pushToDataLayer = (data) => {
        window.dataLayer.push(data);
    }

    // const handleClick = () => {
    //     navigate("/explore/all");

    //     // TEST CODE FOR GOOGLE ANALYTICS
    //     const data = {
    //         event: 'search',
    //         search_term: searchTerm,
    //         search_category: selectedCategory,
    //         search_results: suggestions.map((suggestion) => suggestion['Service name']),
    //     };
    //     pushToDataLayer(data);
    // };



    // const handleClickOutside = (event) => {
    //     if (dropdownRef.current &&
    //         !dropdownRef.current.contains(event.target)) {
    //         setIsDropdown(false);
    //     }

    //     if (suggestionsDropdownRef.current &&
    //         !suggestionsDropdownRef.current.contains(event.target)) {
    //         setIsSuggestionsDropdownOpen(false);
    //     }
    // };

    // useEffect(() => {
    //     setDataLayer(window.dataLayer);
    //     document.addEventListener('mousedown', handleClickOutside);
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, []);


    // const handleButtonClick = (productName, productID) => {
    //     setIsSuggestionsDropdownOpen(false);
    //     const url = generateProductLink(productName, productID);
    //     window.location.href = url;
    // };

    // Controls Navbar bagbround color
    const [navbarColor, setNavbarColor] = useState('transparent');
    const mainHeroTitleRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (mainHeroTitleRef.current) {
                const mainHeroTitleTop = mainHeroTitleRef.current.getBoundingClientRect().top;
                if (mainHeroTitleTop <= 0) {
                    setNavbarColor('#26051C');
                } else {
                    setNavbarColor('transparent');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const categoryDropdownRef = useRef(null);
    const toggleCategoryDropdown = () => {
        setIsCategoryDropdownOpen(!isCategoryDropdownOpen);
        setIsSuggestionsDropdownOpen(false);
    };
    const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState({ label: 'All', urlLabel: 'all', number: null });

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        if (category.number !== null) {
            _retrieveProducts(category.number)
        }
        else {
            _retrieveProducts(null)
        }
    }

    useEffect(() => {
        handleCategoryChange({ label: 'All', urlLabel: 'all', number: null })
    }, [])

    const [data, setData] = useState(null)
    const [filteredServices, setFilteredServices] = useState(null);

    const [loading, setLoading] = useState(false)

    const _retrieveProducts = async (categoryID) => {
        setLoading(true);
        try {
            const products = await retrieveProducts(categoryID)
            setData(products);
            setFilteredServices(products);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const [isSuggestionsDropdownOpen, setIsSuggestionsDropdownOpen] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const suggestionsDropdownRef = useRef(null);

    const handleButtonClick = (productID) => {
        setIsSuggestionsDropdownOpen(false);
        setIsCategoryDropdownOpen(false);
        navigate(`/explore/${productID}`);
    };

    const [searchTerm, setSearchTerm] = useState('');

    const handleChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value) {
            const filteredSuggestions = filteredServices.filter(item =>
                (item['name'] && item['name'].toLowerCase().includes(value.toLowerCase())) ||
                (item['description'] && item['description'].toLowerCase().includes(value.toLowerCase()))
            );

            const sortedSuggestions = filteredSuggestions.sort((a, b) => {
                const aIncludes = a['name'] && a['name'].toLowerCase().includes(value.toLowerCase());
                const bIncludes = b['name'] && b['name'].toLowerCase().includes(value.toLowerCase());
                return (aIncludes === bIncludes) ? 0 : aIncludes ? -1 : 1;
            });

            setSuggestions(sortedSuggestions);
            setIsSuggestionsDropdownOpen(true);
            setIsCategoryDropdownOpen(false);
        } else {
            setIsSuggestionsDropdownOpen(false);
            setSuggestions([]);
            setIsCategoryDropdownOpen(false);
        }
    };

    const handleCategorySelect = (category) => {
        handleCategoryChange(category);
        setIsCategoryDropdownOpen(false);
    };

    return (
        <div
            className="w-full bg-cover bg-left-top md:bg-right 2xl:bg-right-bottom h-fit min-h-screen flex flex-col justify-center 1.5xl:px-[104px]"
            style={{ backgroundImage: `url(${BackgroundImage})` }}>

            <div className={navbarFixedStyling}>
                <MainNav navbarColor={navbarColor} />
            </div>

            <div className="1.5xl:mt-[20px] w-full h-full flex flex-col justify-center px-basePx xs:px-xsPx 1.5xl:px-0">
                <h1 className="w-full md:w-[40rem] lg:w-[48rem] 1.5xl:w-[48rem] 2.5xl:w-[80rem] mb-0 text-left text-white text-[44px] sm:text-[45px] lg:text-[60px] 1.5xl:text-[80px] 1.5xl:text-[80px] 2.5xl:text-[116px] font-allroundgothic font-[600] " ref={mainHeroTitleRef}>The Innovation Hub of Health I.T.</h1>

                <p className="mb-0 md:w-[45rem] lg:w-[50rem] 1.5xl:w-[48rem] 2xl:w-[60rem] mt-[32px] xs:mt-[40px] 2.5xl:mt-[80px] text-left text-white text-[18px] font-proxima-nova">Every healthcare practice comes with a unique workflow. On CharmHealthHub, discover countless tools that can connect seamlessly with your CharmHealth EHR, so you can build and grow your practice just the way you want.</p>


                <div className="md:w-[700px] 3xl:w-[1800px] md:max-h-[56px] xl:max-h-[66px] mt-[45px] xl:mt-[43px] xl:mb-[43px] px-[28px] gap-[16px] flex flex-row items-center bg-white border-exploreSearchBorder border-1 rounded-full relative">
                    <div ref={categoryDropdownRef} className="w-fit flex items-center">
                        <button
                            className="w-fit gap-[16px] pr-[16px] flex flex-row items-center border-r-[1px] border-exploreSearchBorder font-medium"
                            onClick={toggleCategoryDropdown}>
                            <span className="truncate">{selectedCategory.label}</span>
                            {isCategoryDropdownOpen ? (
                                <svg className="" width="14" height="12" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.16026 0.5L17.8205 15.5H0.5L9.16026 0.5Z" fill="#9A0169" />
                                </svg>
                            ) : (
                                <svg className="" width="14" height="12" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.66026 15L0 0L17.3205 0L8.66026 15Z" fill="#9A0169" />
                                </svg>
                            )}
                        </button>
                        {isCategoryDropdownOpen && (
                            <div className="absolute top-[48px] left-0 w-fit sm:pr-4 md:pr-8 px-2 md:px-4 bg-heroSearchbar shadow-lg border-2 border-exploreSearchBorder max-h-64 md:max-h-80 overflow-y-auto">
                                <ul className="py-1">
                                    {buttonLabels.map((label, index) => (
                                        <li key={index}>
                                            <button
                                                className="w-full text-left font-proximanova text-[18px] font-[600] text-[#505050] px-2 md:px-4 py-1 md:py-2 hover:bg-exploreNavBackgroundSelected hover:text-white focus:outline-none"
                                                onClick={() => handleCategorySelect(label)}>
                                                {label.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {isSuggestionsDropdownOpen && suggestions.length > 0 && (
                            <div className="absolute top-[48px] left-0 w-full pt-2 md:pt-4 px-2 md:px-4 bg-heroSearchbar border-2 border-exploreSearchBorder max-h-80 md:max-h-[40rem] overflow-y-auto" ref={suggestionsDropdownRef}>
                                <ul className="list-none p-0 m-0">
                                    {suggestions.map((suggestion, index) => (
                                        <li key={index} className="h-[76px] bg-white shadow-lg p-[6px] mb-2">
                                            <button
                                                className="w-full flex flex-row items-center gap-[16px]"
                                                onClick={() => handleButtonClick(suggestion['id'])}
                                            >
                                                <div className="min-h-[64px] min-w-[64px] max-h-[64px] max-w-[64px] flex items-center justify-center">
                                                    <img
                                                        src={suggestion['thumbnail']
                                                            ? suggestion['thumbnail']
                                                            : charmhealthlogo_placeholder}
                                                        alt="Logo"
                                                        className="h-full w-full max-h-[64px] max-w-[64px] object-contain"
                                                    />
                                                </div>

                                                <div className="flex flex-col">
                                                    <p className="font-proximanova font-[700] text-[18px] text-[#505050] text-left line-clamp-2 mb-0" style={{ lineHeight: '1.20' }}>{suggestion.name}</p>
                                                    <p className="font-proximanova text-[18px] text-[#505050] text-left line-clamp-2 mb-0" style={{ lineHeight: '1.20' }}>{suggestion.description}</p>
                                                </div>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="ml-4 md:ml-6 flex-grow flex justify-center">
                        <input
                            type="text"
                            className="w-full h-10 focus:outline-none font-proximanova text-[18px] text-[#505050] mb-0"
                            placeholder="Search for apps"
                            value={searchTerm}
                            onChange={handleChange}
                        />
                        <button className="">
                            <MagnifyingGlassIcon />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainHero;